<template>
  <zg-kh-account-withdraw-result
    acc-center-router-name="fundAccountHome"
  ></zg-kh-account-withdraw-result>
</template>

<script>
import { AccountWithdrawResult } from 'zgkaihu'
export default {
  name: 'FundAccountWithdrawResult',
  components: {
    [AccountWithdrawResult.name]: AccountWithdrawResult
  }
}
</script>
